import React from 'react';
import { Button, Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle } from '@mui/material';

export default function ExitPendingDialog({ open, busy, onRetry }) {
  return <Dialog open={Boolean(open)} disableEscapeKeyDown aria-labelledby="ielts-exit-title">
    <DialogTitle id="ielts-exit-title">{busy ? 'Saving and closing your test…' : 'Confirm your exit'}</DialogTitle>
    <DialogContent><DialogContentText>{busy ? 'Please wait.' : 'Your answers are saved. Retry to confirm that your test has closed.'}</DialogContentText></DialogContent>
    <DialogActions><Button disabled={busy} onClick={onRetry}>Retry Save & Exit</Button></DialogActions>
  </Dialog>;
}
